"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DrawOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var DrawOutlineSVG = function DrawOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29 28h-1a2.84 2.84 0 01-1.62-.52 9.91 9.91 0 001.75-5.43 5.06 5.06 0 00-.67-2.7 2.91 2.91 0 00-4.92 0 5.06 5.06 0 00-.67 2.7 9.91 9.91 0 001.75 5.43 2.16 2.16 0 01-3.14-.36 4.1 4.1 0 01-.4-.66 5.53 5.53 0 00.3-1.68c0-1.31-.75-1.78-1.38-1.78s-1.38.47-1.38 1.78a5.54 5.54 0 00.3 1.68 4.08 4.08 0 01-.4.66A1.91 1.91 0 0116 28H9.71l15.71-15.71 4.28-4.28a1 1 0 000-1.43L25.42 2.3a1 1 0 00-.71-.3 1.02 1.02 0 00-.72.3L3.01 23.28a.53.53 0 00-.06.1.66.66 0 00-.12.17 1.07 1.07 0 00-.07.19l-.04.11-.71 5V29a.96.96 0 00.04.22A.9.9 0 003 30h13a3.84 3.84 0 003-1.53A3.82 3.82 0 0022 30a4.83 4.83 0 003-1.05A4.83 4.83 0 0028 30h1a1 1 0 000-2zM24.71 4.44l2.85 2.85-2.85 2.86-2.86-2.86zM4.68 24.47L20.43 8.72l2.85 2.85L7.53 27.32l-3.33.48zM25 25.95a7.93 7.93 0 01-1.13-3.9 3.16 3.16 0 01.36-1.63.91.91 0 011.54 0 3.16 3.16 0 01.36 1.63 7.93 7.93 0 01-1.13 3.9z"
  }));
};
exports.DrawOutlineSVG = DrawOutlineSVG;
DrawOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DrawOutlineSVG);
exports.default = _default;